import React from 'react'
import ChangelogDate from '../ChangelogDate'
import ChangelogTitle from '../ChangelogTitle'
import ChangelogTag from '../ChangelogTag'
import { renderAst } from '../../helpers/html'
import * as DataHelpers from '../../helpers/changelog/data'
import styles from './styles.module.css'

function ChangelogContent({ data }) {
  return (
    <div className={styles.changelogTimeline}>
      {data.map((dataGroupMonth, index) => {
        const { month } = DataHelpers.getDataFromLogGroup(dataGroupMonth)

        return (
          <section key={index} className={styles.changelogTimelineGroup}>
            <div className={styles.changelogTimelineLabel}>
              <span>{month}</span>
            </div>

            <div className={styles.changelogTimelineList}>
              {dataGroupMonth.edges.map((log, index) => {
                const { frontmatter, htmlAst } = log.node
                const { date, title, app, changeType } = frontmatter
                return (
                  <div key={index} className={styles.changelogItemBody}>
                    <ChangelogDate>{date}</ChangelogDate>
                    <ChangelogTitle>{title}</ChangelogTitle>

                    <div className={styles.changelogWrapperTag}>
                      {app.map((appItem, appIndex) => (
                        <ChangelogTag key={appIndex} filterGroupName="solution">
                          {appItem}
                        </ChangelogTag>
                      ))}
                      <ChangelogTag date={date} tooltip={true} filterGroupName="changeType">
                        {changeType}
                      </ChangelogTag>
                    </div>
                    <div>{renderAst(htmlAst)}</div>
                  </div>
                )
              })}
            </div>
          </section>
        )
      })}
    </div>
  )
}

export default ChangelogContent
